import { salesService } from "@features/sales/SalesService";
import { ISaleOutputDTO, ValidateSaleTokenInput } from "@/schemas/sales";
import createEntitySlice from "@services/createEntitySlice";
import { createAsyncThunk } from "@reduxjs/toolkit";

const {
  reducer: salesReducer,
  actions: salesActions,
  fetchAll: fetchSales,
  fetchById: fetchSaleById,
  createEntity: createSale,
  updateEntity: updateSale,
  deleteEntity: deleteSale,
} = createEntitySlice<ISaleOutputDTO>("sales", salesService);

const generateSaleToken = createAsyncThunk(
  "sales/generateToken",
  async (
    { id, phone }: { id: string; phone?: string },
    { rejectWithValue },
  ) => {
    try {
      const response = await salesService.generateToken(id, phone);
      if ("data" in response) {
        return response.data;
      }
      return rejectWithValue(response);
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

const validateSaleToken = createAsyncThunk(
  "sales/validateToken",
  async (data: ValidateSaleTokenInput, { rejectWithValue }) => {
    try {
      const response = await salesService.validateToken(data);
      if ("data" in response) {
        return response.data;
      }
      return rejectWithValue(response);
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export {
  salesReducer,
  salesActions,
  fetchSales,
  fetchSaleById,
  createSale,
  updateSale,
  deleteSale,
  generateSaleToken,
  validateSaleToken,
};
